import PhotoEditorModal from 'components/PhotoEditorModal'
import React, { useState } from 'react'
interface PhotoProps {
  selectedImage: File | null
  setSelectedImage: (content: File | null) => void
}

const Photo: React.FC<PhotoProps> = ({ selectedImage, setSelectedImage }) => {
  const [isModal, setModal] = useState(false)

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0]
      setSelectedImage(file)
      setModal(true)
    }
  }

  return (
    <>
      {isModal && selectedImage && <PhotoEditorModal
        photo={selectedImage}
        setPhoto={setSelectedImage}
        close={() => {
          setModal(false)
        }}
      />}

      <div className='infoLabel'>
        Dodaj główne zdjęcie, może to być zdjęcie pomnika lub portret osoby
      </div>
      <div className="myInput">
        <label>Ustal zdjęcie główne</label>
        <div className='drop' onClick={() => document.getElementById('fileInput')?.click()}>
          {!selectedImage &&
            <>
              <i className='icon icon--add-photo s32'></i>
              <span>Kliknij, aby dodać zdjęcie</span>
            </>}
          <input
            type="file"
            id="fileInput"
            style={{ display: 'none' }}
            onChange={handleImageChange}
            accept="image/*"
          />
          {selectedImage && (<>
            <div className='imgWrap'>
              <img src={URL.createObjectURL(selectedImage)} alt="Podgląd miniaturki" style={{ width: '100%', height: '50vh', objectFit: 'cover' }} />
            </div>
          </>)}
        </div>
        {selectedImage && <div className="dropButtons">
          <button
            className='btn btn--round'
            onClick={() => document.getElementById('fileInput')?.click()}>
            <i className='icon icon--settings'></i>
            Zmień zdjęcie
          </button>

          <button
            className='btn btn--round'
            style={{ flexGrow: '1' }}
            onClick={e => {
              e.stopPropagation()
              setModal(true)
            }}>
            <i className='icon icon--settings'></i>
            Edytuj
          </button>
        </div>}
      </div>
    </>
  )
}

export default Photo